import { Injectable } from '@angular/core';
import {AppPageConfig,Data} from '../model/xmlconfig/app.page.config';
import {AppPageElement as AppPageTemplateElement } from '../model/xmlconfig/app.page.element';
import {AppSelectItems} from '../model/xmlconfig/app.select.items';
import { SysAccount} from '../model/sys.account';
import {AppPageTemplateConotent} from '../model/xmlconfig/app.page.template.content';
import {SysMenus as AppMenus, SysMenus} from '../model/sys.menus';
import {SysToken as  Token} from '../model/sys.token';
import {Router} from '@angular/router';
import { NavController,Platform} from '@ionic/angular';
import { Buffer } from 'buffer';
import {BaseModal} from '../model/base';
import { PlatformLocation} from '@angular/common';
import {MessageclientService} from '../service/messageclient.service';
import { Device } from '@ionic-native/device/ngx';
import {File} from '@ionic-native/file/ngx';
import { WebResponesContext,AgentConfigParams } from '../model/common';

declare var app;
declare var cordova:any;
declare var wx:any;//启用微信客户端
@Injectable({
  providedIn: 'root'
})
/**公共实体类 */
export class CommonService {

  constructor(
    private base:BaseModal,
    private router:Router,
    private navctr:NavController,
    private msg:MessageclientService,
    private platform:Platform,
    private device:Device,
    private file:File,
    private platformlocation:PlatformLocation
  ) { }

  
  numberAddZore(num: Number):string{
    return num < 10 ? '0' +num : '' + num;
  }
  /**
   * 加密方法（base64位加密）
   *@param encodeStr 加密字符串
   */
  encodeBase64( encodeStr: string ): string {
    return new Buffer( encodeStr ).toString( 'base64' );
  }
  /**
   * 解密方法（只能处理64为密文）
   * @param decodeStr 加密密文
   */
  decodeBase64( decodeStr: string ): string {
    return new Buffer( decodeStr, 'base64' ).toString();
  }
/**
 * 封装时间段查询
 * @param startDate 开始日期
 * @param endDate 结束日期
 */
  BetweenDate(startDate,endDate){
    let obj={
      "BeforeValue": startDate,
      "EndValue": endDate,
      "Type": "Between"
    };
    return obj;
  }
  /**需要模糊查询的值 */
  LikeSearch(value:any){
    return {
      "Value":value,
      "LikeType":"Middle",
      "Type":"Like"
    }
  }
  /**
   * 获取当前时间包含年月日
   */
 get getNowdate(){
    let date:Date = new Date();
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any = date.getDate();
   month=tmp1;
   day = tmp2;
   if(tmp1 <10){
    month = "0"+tmp1;
   }
   if(tmp2<10){
    day = "0"+tmp2;
   }
   year = riqi;
    return year+"-"+month+"-"+day+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
  }
  /**
   * 获取当前日期("yyyy-MM-dd")
   */
 get getNow(){
    let date:Date = new Date();
    // console.log(1001011);
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any =  date.getDate();
   month=tmp1;
   day = tmp2;
   if(tmp1 <10){
    month = "0"+tmp1;
   }
   if(tmp2 <10){
    day = "0"+tmp2;
   }
   year = riqi;
    return year+"-"+month+"-"+day;
  }
    /**
   * 获取当前日期的年月("yyyy-MM")
   */
 get getNowYearAndMonth(){
  let date:Date = new Date();
  // console.log(1001011);
  let year,month;
 let riqi = date.getFullYear();
 let tmp1:any = date.getMonth()+1;
 month=tmp1;
 if(tmp1 <10){
  month = "0"+tmp1;
 }
 year = riqi;
  return year+"-"+month;
}
  /**
   * 获取当前年月
   */
  get getYearMonth(){
    let date:Date = new Date();
    // console.log(1001011);
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   month=tmp1;
   if(tmp1 <10){
    month = "0"+tmp1;
   }

   year = riqi;
    return year+"/"+month;
  }
  /**
   * 获取当前时间,yyyymmddHHmmss
   */
  get getNowDatetime(){
    let date:Date = new Date();
    console.log(date,"年月日");
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any =  date.getDate();
   month=tmp1;
   day = tmp2;
   if(tmp1 <10){
    month = "0"+tmp1;
   }
   if(tmp2<10){
    day = "0"+tmp2;
   }
   year = riqi;
   let str:string = year.toString()+month.toString()+day.toString()+date.getHours().toString()+date.getMinutes().toString()+date.getSeconds().toString();
   console.log(str);
    return str;
  }
  /**
   * 获取当前时间拼接
   */
  get getNowDatetimeall(){
    let date:Date = new Date();
    console.log(date,"年月日");
    let year,month,day,getHours,getMinutes,getSeconds,getMilliseconds;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any =  date.getDate();
   let tmp3:any = date.getHours();
   let tmp4:any =  date.getMinutes();
   let tmp5:any =  date.getSeconds();
   let tmp6:any =  date. getMilliseconds();
  
   month=tmp1;
   day = tmp2;
   getHours=tmp3;
   getMinutes = tmp4;
   getSeconds=tmp5;
   getMilliseconds=tmp6
   if(tmp1 <10){
    month = "0"+tmp1;
   }
   if(tmp2<10){
    day = "0"+tmp2;
   }
   if(tmp3 <10){
    getHours = "0"+tmp3;
   }
   if(tmp4<10){
    getMinutes = "0"+tmp4;
   }
   if(tmp5 <10){
    getSeconds = "0"+tmp5;
   }
   if(tmp6 <10){
    getMilliseconds = "0"+tmp5;
   }
   
   year = riqi;
   let str:string = year.toString()+month.toString()+day.toString()+getHours.toString()+getMinutes.toString()+getSeconds.toString()+getMilliseconds.toString();
  //  let str:string = year.toString()+"/"+month.toString()+"/"+day.toString()+" "+getHours.toString()+":"+getMinutes.toString()+":"+getSeconds.toString()+getMilliseconds.toString();
   console.log(str);
    return str;
  }
  /**
   * token超时
   */
  loginTimeOut(){
    const that = this;
    localStorage.removeItem("tokentimeOut");
    let expiresIn:number = Number(that.getToken.ExpiresIn);//that.getToken.ExpiresIn;
    //console.log("token过期时间:"+expiresIn);
    let y:number = 0;
  let timeout = setInterval(function(){
    // console.log(y);
    if(!that.GetAccount.IsLogin){
      clearInterval(timeout);
      localStorage.removeItem("tokentimeOut");
      y = 0;
    }
    if(y == expiresIn){
      clearInterval(timeout);
      y = 0;
      localStorage.setItem("tokentimeOut","true");
      }
      y++;
    },1000);
  }
  /**
   * 算出服务器和本地时间差
   */
  getOutnumber(){
    let token = this.getToken;
    if(token){
      let encodetoken = new Buffer(token.AccessToken.split('.')[1], 'base64').toString();
      let tokenData = JSON.parse(encodetoken);
      let Nowtimestamp = Math.round(new Date().getTime() / 1000);//获取当前时间的时间戳
        let timedifference =  tokenData.nbf - Nowtimestamp;//保证本地时间与服务器同步
      localStorage.setItem("exp",tokenData.exp);//过期时间戳
      localStorage.setItem("timediffer",timedifference.toString());//误差时间戳
    }
       // console.log(tokenData.);
  }

  /**
   * 
   * @param url 跳转地址
   * @param title 页面标题
   */
  goWebPage(url:string,title:string) {
    // this.router.navigate(['/webpage', { url: url, name: title}]);
    this.Go('/webpage', { url: url, name: title});
  }
  /**
   * 计算倒计时
   */
 GetTimeOut():Promise<any>{
  let that = this;
  return new Promise<any>((resolve,reject)=>{
    if( that.base.Minute<=0){
      reject(false);
    }else{//倒计时启动时
      let icountTime=setInterval(()=>{
        let obj={};
          obj["check"]=false;
          obj["inter"]=icountTime;
        if(!that.base.InterVal){
          resolve(obj);
        }else{
      // console.log(that.base.Second);
      if(that.base.Second<10){
        //如果秒数少于10在前面加上0
        that.base.timeOut =  that.base.Minute+":0"+that.base.Second;
                }else{
         that.base.timeOut =  that.base.Minute+":"+that.base.Second;
                }
                that.base.Second--;
                if(that.base.Second<0){
                   that.base.Minute--;
                   if(that.base.Minute<=0){
                    obj["check"]=true;
                    obj["inter"]=icountTime;
                    resolve(obj);
                   }
                    //如果秒数少于0就变成59秒
                    that.base.Second=59;
          }
        }
       },1000);
    }

  });
 }
  /**
   * 存储登录信息数据
   * @param obj 需要存储的对象名称
   */
  // SaveStorage(obj:WebResponesContext):void{
    SaveStorage(obj:any):void{
      const that =this;
    if(obj){
      //存储用户信息
      if(obj.Account){
        obj.Account.IsLogin=true;
        localStorage.setItem("account",JSON.stringify(obj.Account));
      }
      //存取菜单权限
      if(obj.Status.AppMenus){
        if(obj.Status.AppMenus.length>0){
          localStorage.removeItem("menus");
          let arrayMenus=that.GetMenusDataList(obj.Status.AppMenus);
          // localStorage.setItem("menus",JSON.stringify(obj.Account.AppMenus));//存储菜单信息
          localStorage.setItem("menus",JSON.stringify(arrayMenus||[]));//存储菜单信息
        }
      }
      //如果后端xml修改后更新本地json文件
      if(obj.Status.AppPageConfig){
        const pagesData:Array<AppPageConfig>=obj.Status.AppPageConfig.pages;//获取修改过的xml文件
        let oldPagesData:Array<AppPageConfig>=that.GetStorageKey("pageconfig")||[];//获取所有xml文件
        // console.log(oldPagesData.length,"获取xml");
        // console.log(pagesData.length,"获取xml2");
        if(pagesData.length>0){
          pagesData.forEach((pages,index)=>{
           let findIndex=oldPagesData.findIndex(ut=>ut.Key.trim().toLowerCase()===pages.Key.trim().toLowerCase());
           if(findIndex>=0){
            oldPagesData[findIndex].Data=pages.Data;
           }else{
            oldPagesData.push(pages);//如果新增xml文件则直接添加进去。
           }
          });
          localStorage.setItem("pageconfig",JSON.stringify(oldPagesData));
           //#region  保存缓存文件到手机安装目录中，卸载程序则自动删除 
           if(!that.IsWeixinBrowser){
            try{
              that.WriteExistingFile(JSON.stringify(oldPagesData)).then(result=>{
                console.log(result);
              }).catch(error=>{
                console.error(error,"保存缓存文件到手机安装目录中");
              });
             }catch(err){
              console.error(err,"保存缓存文件到手机安装目录中try");
             }
           }
         
          //#endregion
        }
        // if(pagesData.length>0){
        //   pagesData.forEach((pages,index)=>{
        //     let isChanage:boolean = false;
        //     oldPagesData.forEach((oldEl,oldIndex)=>{
        //       if(oldEl.Key.trim().toLowerCase()==pages.Key.trim().toLowerCase()){
        //         isChanage=true;
        //         oldPagesData[oldIndex].Data=pages.Data;
        //       }
        //     });
        //       if(!isChanage){
        //         oldPagesData.push(pages);//如果新增xml文件则直接添加进去。
        //       }
        //   //  let findIndex=oldPagesData.findIndex(ut=>ut.Key.trim().toLowerCase()===pages.Key.trim().toLowerCase());
        //   //  if(findIndex>=0){
        //   //   oldPagesData[findIndex].Data=pages.Data;
        //   //  }else{
        //   //   oldPagesData.push(pages);//如果新增xml文件则直接添加进去。
        //   //  }
        //   });
        //   // console.log(oldPagesData,"oldPagesData");
        //   localStorage.setItem("pageconfig",JSON.stringify(oldPagesData));
        //   //#region  保存缓存文件到手机安装目录中，卸载程序则自动删除 
        //    try{
        //     this.WriteExistingFile(JSON.stringify(oldPagesData)).then(result=>{
        //       console.log(result);
        //     }).catch(error=>{
        //       console.log(error,"保存缓存文件到手机安装目录中");
        //     });
        //    }catch(err){
        //     console.log(err,"保存缓存文件到手机安装目录中try");
        //    }
        //   //#endregion
        // }
        localStorage.setItem("pageConfigTime",obj.Status.AppPageConfig.Stamp|| 0);//缓存当前页面时间戳

      }
      //缓存Token
      if(obj.Status.Token){
        localStorage.setItem("token",JSON.stringify(obj.Status.Token));
      //  this.getOutnumber();
      }

      //模块权限
      if(obj.Status.PageMode){
        // console.log("PageMode");
        if(Object.keys(obj.Status.PageMode).length>0){
          let oldTempPage:any = obj.Status.PageMode;
          if(this.GetStorageKey("pagemode")){
           let  TempPage=this.GetStorageKey("pagemode");
            oldTempPage = Object.assign(oldTempPage,TempPage);
          }
          localStorage.setItem("pagemode",JSON.stringify(oldTempPage));
        }
      }
      //数据权限
      if(obj.Status.PageFieldPermission){
        if(Object.keys(obj.Status.PageFieldPermission).length>0){
          localStorage.setItem("fieldpermission",JSON.stringify(obj.Status.PageFieldPermission));
        }
      }
      //采集点
      if(obj.Status.TempPage){
        if(Object.keys(obj.Status.TempPage).length>0){
          let oldArray:Array<any> = obj.Status.TempPage;
          if(this.GetStorageKey("temppage")){
             oldArray=this.GetStorageKey("temppage");
            obj.Status.TempPage.forEach((newtempage,index)=>{
              let findIndex=oldArray.findIndex(ut=>ut.pagename.trim().toLowerCase()===newtempage.pagename.trim().toLowerCase());
              if(findIndex>=0){
                oldArray[index]=newtempage;
              }else{
                oldArray.push(newtempage);
              }
            });
          }
          localStorage.setItem("temppage",JSON.stringify(oldArray));
        }
      }
      //判断是否PG是否排班
      if(obj.Status.Info){
        if(obj.Status.Info.SN){
          localStorage.setItem("tbstore",JSON.stringify({"ID":obj.Status.Info.SN.a_FK_Store_ID,"name":obj.Status.Info.SN.c_Name,"address":obj.Status.Info.SN.c_StreetAddress}));
          localStorage.setItem("pginfo",JSON.stringify(obj.Status.Info.SN))
       }else{
          if(obj.Status.Info.InStore){
            localStorage.setItem("tbstore",JSON.stringify({"ID":obj.Status.Info.StoreList[0]}));
          }
       }
      }
    }
  }
  /**
   * 过滤当前页面，以及数据权限
   * @param allPageModel 系统xml
   * @param configName 当前页面名称
   */
  private PageModalOrPermission(allPageModel:Data,configName?:string):Data{
  const that=this;
   let fieldPage:Data= that.GetFieldPageConfig(configName);//获取当前页面配置数据
   if(fieldPage){
     //判断首节菜单是否有权限
     let head="";
     if(fieldPage.head){
      head=fieldPage.head.name||"";
     }
   if(head!=""){
    delete allPageModel.head;
  }else{
    if(fieldPage.head){
      if(fieldPage.head.element.length>0){
        fieldPage.head.element.forEach((element,index)=>{
         let head_element=element||"";
        if(head_element!=""){
         allPageModel.head.element.splice(index,1);
        }
        });
      }
    }
  }
  
  //判断内容块是否有权限
  if(fieldPage.template.length>0){//判断当前页面是否有模块template
   fieldPage.template.forEach((item,tindex)=>{
    let j=allPageModel.template.length;
    while(j--){
      if(allPageModel.template[j].name.trim().toLowerCase()===item.name.toString().toLowerCase()){
        if(!item.head && !item.content){
          allPageModel.template.splice(j,1);
         }
         if(item.head){
          if(item.head.name){
            delete allPageModel.template[j].head;
          }else{
            if(item.head.element.length>0){//判断头部模块下的element是否有权限
              item.head.element.forEach(heade=>{
                let hi=allPageModel.template[j].content.element.length;
                while(hi--){
                  if(allPageModel.template[j].head.element[hi].name.toString().trim().toLowerCase()==heade.toString().trim().toLowerCase()){
                    allPageModel.template[j].head.element.splice(hi,1);
                  }
                }
              });
              // allPageModel.template[tindex].head.element=this.ElementFilter(item.head.element,tindex,allPageModel.template[tindex].head.element);
            }
          }
         }
         if(item.content){//content模块存在.如果 content Name属性存在，就判断无权限,直接删除,如果content节点存在,element节点也存在需要遍历删除
          if(item.content.name){
           delete allPageModel.template[tindex].content;
         }else{
               if(item.content.element.length>0){
                item.content.element.forEach(ele=>{
                  let ci=allPageModel.template[j].content.element.length;
                  while(ci--){
                    if(allPageModel.template[j].content.element[ci].name.toString().trim().toLowerCase()==ele.toString().trim().toLowerCase()){
                      allPageModel.template[j].content.element.splice(ci,1);
                    }
                  }
                });
                //  allPageModel.template[tindex].content.element=this.ElementFilter(item.content.element,tindex,allPageModel.template[tindex].content.element,item.content.configName);
               }
             }
        }
      }
     }
   });
  }
  }
  //处理当前页面的字段权限过滤
  if(allPageModel.head)
  {
    allPageModel.head.element.forEach((tes,tindex)=>{
      if(tes.selectItemList.gridViewConfigName){
        allPageModel.head.element[tindex].selectItemList.selectItem=this.SelectItemsFilter(tes.selectItemList.selectItem,tes.selectItemList.gridViewConfigName);
      }
    });
  }
  if(allPageModel.template.length>0){
    allPageModel.template.forEach((temp,indexs)=>{
      //头部节点
      if(temp.head){
        if(temp.head.element.length>0){
          temp.head.element.forEach((hitem,hindex)=>{
            if(hitem.selectItemList.gridViewConfigName){
              allPageModel.template[indexs].head.element[hindex].selectItemList.selectItem=this.SelectItemsFilter(hitem.selectItemList.selectItem,hitem.selectItemList.gridViewConfigName);
            }
          });
        }
      }
      //内容块节点
     
      if(temp.content){
        if(temp.content.element.length>0){
          if(temp.content.configName){
            allPageModel.template[indexs].content=this.ContentPersionFilter(allPageModel.template[indexs].content,temp.content.configName.trim());
          }
          temp.content.element.forEach((eitem,eindex)=>{
            if(eitem.selectItemList.gridViewConfigName){
              allPageModel.template[indexs].content.element[eindex].selectItemList.selectItem=this.SelectItemsFilter(eitem.selectItemList.selectItem,eitem.selectItemList.gridViewConfigName);
            }
            });
        }
      }
      });
  }
  return allPageModel;
  }
  /**
   * 过滤页面中Element没有权限的节点；
   * @param _element 当前页面Element节点
   * @param index 当前节索引
   * @param All 本地数据对应的节点Element
   * @param configName 判断父级是否有ConfigName
   */
  private ElementFilter(_element:Array<AppPageTemplateElement>,index:number,AllEle:Array<AppPageTemplateElement>,configName:string=null):Array<AppPageTemplateElement>
  {
    //console.log(8008088);
    //先判断是否有权限菜单权限，过滤掉没有权限的Element
    _element.forEach((Nitem,Nindex)=>{
      let c_E:any=Nitem||"";//节点没有权限时，处理本地缓存中对应的节点
        if(c_E.trim()!=""){
          let j=AllEle.length;
          while(j--){
               if(AllEle[j].name.trim().toLowerCase()===c_E.toString().toLowerCase()){
                AllEle.splice(j,1);
               }
          }
        }
    });
    //如果Content节点上存在ConfigName时过滤字段权限
    if(configName && configName!=""){
      const filterE=this.GetStorageKey("fieldpermission")||{};//获取字段权限
      let k=AllEle.length;
      while(k--){
        let itemkey=filterE[configName];
        if(itemkey){
          const ekey= itemkey[configName][AllEle[k].field];
          if(typeof(ekey)!="undefined"){
            if(ekey===0){//表示不可见状态
              AllEle.splice(k,1);
            }else if(ekey===2){//表示只读状态
              AllEle[k].readonly=true;
            }
          }

        }
      }
    }
  return AllEle;
  }
/**
 * 过滤content存在ConfigName时的字段权限；
 * @param AllEle 获取对应的Content节点
 * @param configName 当前的xml名称
 */
  ContentPersionFilter(AllEle:AppPageTemplateConotent,configName:string=null):AppPageTemplateConotent{
    const filterE=this.GetStorageKey("fieldpermission")||{};//获取字段权限
    let k=AllEle.element.length;
    while(k--){
      let itemkey=filterE[configName];
      if(itemkey){
        const ekey= itemkey[AllEle.element[k].name];
        if(typeof(ekey)!="undefined"){
          if(ekey===0){//表示不可见状态
            AllEle.element.splice(k,1);
          }else if(ekey===2){//表示只读状态
            AllEle.element[k].readonly=true;
          }
        }
      }
    }
    return AllEle;
  }
  /**
   * element节点下selectItem节点字段权限
   * @param selectItem  当前xml selectItem节点
   * @param ConfigName  当前Element节点 ConfigName属性值
   */
  private SelectItemsFilter(selectItem:Array<AppSelectItems>,ConfigName:string){
   const filterE=this.GetStorageKey("fieldpermission")||{};//获取字段权限
  //  let newArrayItem:Array<AppPageTemplateSelectItem>=new Array<AppPageTemplateSelectItem>();
   if(filterE[ConfigName]){
     const len=selectItem.length-1;
     for(let t=len;t>=0;t--){
      const pkey= filterE[ConfigName][selectItem[t].field];
      if(typeof(pkey)!="undefined"){
        if(pkey===0){
          selectItem.splice(t,1);
        }else if(pkey===2){
          selectItem[t].readonly=true;
        }
      }
     }
   }
   return selectItem;

  }
  /**
   * 遍历菜单,把一次菜单但不是首页的放入其他一次菜单中
   * @param _menus 菜单对象
   */
  private GetMenusDataList(_menus:Array<any>){
    let meus_False:Array<any>=new Array<any>();
    let arrayList:Array<any>=new Array<any>();
    _menus.forEach((items,index)=>{
      if(items.IsHome===false){
        meus_False.push(items);
      }
    });
    _menus.forEach((items,index)=>{
      if(items.IsHome===true){
        if(typeof(items.menus)!="undefined"){
            meus_False.forEach((its,index)=>{
            items.menus.push(its);
          });
        }
        arrayList.push(items);
      }
    });
    return arrayList;
  }
  /**
   * 获取当前存储的用户信息数据，如key为"account","menus","pageconfig","token";
   * @param obj 对应的key值
   */
  GetStorageKey(obj:string):any{
    let body:JSON=null;
    if(obj){
      let Datakey=localStorage.getItem(obj);
      if(Datakey){
        body=JSON.parse(Datakey);
      }
    }
    return body;
  }
  /**
   * 移除当前缓存数据
   * @param obj 对应的key值
   */
  RemoveStorageKey(obj:string):boolean{
    let istrue:boolean=false;
    if(obj){
      if(this.GetStorageKey(obj)){
        istrue=true;
        localStorage.removeItem(obj);
      }
    }
    return istrue;
  }
  /**
   * 清空当前缓存数据
   */
  removeAllStorage(){
    localStorage.clear();
  }
  /**
   * 获取登录消息
   */
 get GetAccount():SysAccount{
    let account:SysAccount = new SysAccount();
    if(this.GetStorageKey("account")){
      account = this.GetStorageKey("account");
    }
    return account;
  }
  /**
   * 角色code返回
   */
  get GetRoleSFA(){
    const that = this;
     let Roname:string= null;
     if(that.GetAccount.Roles){
      if(that.GetAccount.Roles.length>0){
        Roname = that.GetAccount.Roles[0].RoleName;
       }
       that.GetAccount.Roles.forEach(items=>{
         if(items.Code){
           if(items.Code.toLocaleLowerCase().toString()=="1001" ||items.Code.toLocaleLowerCase().toString()=="1004" ||items.Code.toLocaleLowerCase().toString()=="1003" ||items.Code.toLocaleLowerCase().toString()=="1002" ){
            Roname =  items.RoleName;
           }
         }
       });
     }
    return Roname;
  }
  /**
   * 用户退出登录
   */
  public LoginOut(){
    let that=this;
    that.msg.Confirm("确定注销当前帐号吗？").then(data=>{
      if(data){
        that.removeItem(new Array<string>("token","pginfo","tbstore","setMap","pgindata","pgondate","startDate","enddate","clock","clockOut","backurl","exp","menus","readCount","timediffer","badge_"+that.GetAccount.Id,"ISCLOSE","INFO","loginError","INFOBAGE"));
        sessionStorage.clear();
        // console.log(data);
        let out:SysAccount=new SysAccount();
          that.base.account = out;
          that.base.subMenus=[];
          localStorage.setItem("account",JSON.stringify(out));
         that.href('/login');
        // that.router.navigate(['/login'],{replaceUrl:true});
      }
    })
  }
  /**
   * 移除本地缓存数据,根据对应的key删除
   * @param item localStorage对应的key值，可以传多个,["key1","key2"...]
   */
  removeItem(item:Array<string>=[]){
    item.forEach(its=>{
       localStorage.removeItem(its);
    });

  }
  /**
   * token过期
   */
  public LoginOutToken(){
    let that=this;
    let out:SysAccount=new SysAccount();
    that.base.account = out;
    that.base.subMenus=[];
    localStorage.setItem("account",JSON.stringify(out));
   that.href('/login');
  }
  /**
   * 页面跳转连接
   * @param url 需要跳转的url
   * @param isRefresh 是否刷新页面，针对返回上一页时处理
   */
  public href(url:string,isRefresh:boolean=false){
    //console.log(url);
    // let urlArray:Array<string>=new Array<string>();
    //     urlArray.push(url);
  //  return this.router.navigate(urlArray,{replaceUrl:isRefresh});
   return this.Go(url,{replaceUrl:isRefresh});
  }
  /**
   * 获取一级菜单
   * @param url 
   */
  public getFirstMenuUrl(url:string):boolean{
    let meunsUrl:boolean=false;
    //console.log("menus");
     //获取一级菜单的url地址
     this.GetMenus.forEach((menus)=>{
       if(this.getUrlList(url,menus.Component)){
        meunsUrl=true;
       }
      // if(menus.Url.trim().toLowerCase()===url.replace('/tabs/','').trim().toLowerCase()){
      //     meunsUrl=true;
      // }
      });
    return meunsUrl;
  }
  /**
   * 获取是否第一级菜单
   * @param url 获取当前的url地址
   * @param menuUrl 数据库返回的url地址
   */
  public getUrlList(url,menuUrl:string):boolean{
     let _urlsplit=url.split('/');
     let homeurl = false;
     _urlsplit.forEach((items,index)=>{
         if(items.toLowerCase()==menuUrl.toLowerCase()){
          homeurl = true;
         }
     });
    //  for(let i =0; i> url.length; i++){
    //    if(menuUrl.toLowerCase()==url[i])
    //    {
    //     homeurl = true;
    //    }
    //  }
     return homeurl;
  }

  /**
   * 获取选中的一级菜单
   * @param url 
   */
  public getMenuAction(url:string):number{
    let meunsAct: number;
     //获取一级菜单的url地址
     this.GetMenus.forEach((menus,index)=>{
      if(url.replace('/tabs/','').trim().toLowerCase().indexOf(menus.Url.trim().toLowerCase()) >= 0){
        meunsAct=index;
      }
      // if(menus.Url.trim().toLowerCase()===url.replace('/tabs/','').trim().toLowerCase()){
      //   meunsAct=index;
      // }
      });
    return meunsAct;
  }

  /**
   * 过滤url地址
   * @param url 
   */
  public replaceMenusUrl(url:any){
    let _url:any = undefined;
    if(url){
      _url = url.replace('/tabs/','');
    }
   return _url;
  }
  /**
   * 对比一级菜单url地址
   * @param url url地址
   */
  public getMenusUrl(url:string=""):boolean{
    // //console.log(url);
     const that=this;
     let meunsUrl:boolean=false;
     if(url == "/login"){
      meunsUrl=true;
     }else{
      //获取一级菜单的url地址
      that.GetMenus.forEach((menus)=>{
        if(menus.Url.trim().toLowerCase()===url.replace('/tabs/','').trim().toLowerCase() && menus.IsHome && menus.IsMainMenu){
            meunsUrl=true;
        }
        });
     }
   return meunsUrl;
  }
   /**
   * 判断是否是主菜单
   * @param configName 当前跳转的ConfigName
   */
  public getFirstMenusConfigName(ConfigName:string):boolean{
    // //console.log(url);
     const that=this;
     let firsrMenus:boolean=false;
     that.GetMenus.forEach((menus)=>{
      if(menus.Component.trim().toLowerCase()===ConfigName.trim().toLowerCase() && menus.IsHome && menus.IsMainMenu){
        firsrMenus=true;
      }
      });
   return firsrMenus;
  }
  /**
   * 登录时获取有二级菜单的数据数据
   */
  public get getHomeMenus():Array<SysMenus>{
    let sb:Array<SysMenus> = new Array<SysMenus>();
    const that=this;
    that.GetMenus.forEach((menus)=>{
      if( typeof(menus.menus)!="undefined" || !menus.IsHome)
      {
        sb.push(menus);
      }
      });
      return sb;
  }
  /**
   * 获取首页展示菜单,只能一个
   */
  public getHonmeUrl():SysMenus{
    // //console.log(1001011);
    let sb:SysMenus = new SysMenus();
    const that=this;
    that.GetMenus.forEach((menus)=>{
      if( menus.IsHome && menus.IsMainMenu)
      {
        sb = menus;
      }
      });
      return sb;
  }
  /**
   * 退出程序
   */
 public exitApp():void{
    let that=this;
    that.msg.Confirm("确定退出应用程序？").then(data=>{
      if(data){
        navigator['app'].exitApp();
      }
    });
  }
  /**
   * 获取菜单节点
   */
  get GetMenus():Array<AppMenus>{
    let appMenus:Array<AppMenus>= new Array<AppMenus>();
    let Menus=this.GetStorageKey("menus");
    if(Menus){
      appMenus=Menus;
    }
    return appMenus;
  }
  /**
   * 第一次登录时页面配置文件存入全部存入
   * @param data 返回的页面数据格式，并且缓存当前文件的时间戳
   */
  SetAllPageConfig(data:any){
    console.log(data,"configName");
    if(data){
    let pages=data.pages||data.Pages;
    let stamp=data.stamp||data.Stamp;
      if(pages.length>0){
      //   const localtime=this.GetStorageKey("pageConfigTime");
      //   const time=stamp;
      //   if(time && localtime){
      //     if(time.toString()===localtime.toString()){
      //     return;
      //     }
      // }
      localStorage.setItem("pageconfig",JSON.stringify(pages)|| null);//缓存所有页面数据
      localStorage.setItem("pageConfigTime",stamp|| null);//缓存当前页面时间戳
       console.log("缓存数据","缓存");
       try{
          pages.forEach(item=>{
            let _temp:any={Key:null,Data:null};
              _temp["Key"]=item.Key;
              _temp["Data"]=item.Data;
            sessionStorage.setItem(item.Key,JSON.stringify(_temp));
        });
       }catch(err){
        console.log(err,"缓存数据失败");
       }
      
      if(this.platform.is("cordova")){
        //#region  保存缓存文件到手机安装目录中，卸载程序则自动删除 
          try{
            this.WriteExistingFile(JSON.stringify(pages)).then(result=>{
              console.log(result);
            }).catch(error=>{
              console.log(error,"第一次登录时页面配置");
            });
          }catch(err){
            console.log(err,"第一次登录时页面配置 try");
          }
        //#endregion
      }
      }
    }
  }
  /**
   * 获取页面数据节点
   */
   GetAllPageConfig(key:string):Array<AppPageConfig>{
    let appwebPage:Array<AppPageConfig>= new Array<AppPageConfig>();
    let appweb:Array<any> = new Array<any>();
    if(sessionStorage.getItem(key)){
      try{
       let _t=JSON.parse(sessionStorage.getItem(key))||{};//获取当前页面的配置数据
       appweb.push(_t);
      }catch(err){
       console.log(err,"获取当前页面节点失败");
      }
    }else{
      appweb=this.GetStorageKey("pageconfig");
      try{
        if(appweb.find((item)=>item.Key==key)){
          let _mp:any = appweb.find((item)=>item.Key==key);
          appweb.push(_mp);
          let _temp:any={Key:null,Data:null};
                            _temp["Key"]=_mp.Key;
                            _temp["Data"]=_mp.Data;
          sessionStorage.setItem(_mp.Key,JSON.stringify(_temp));
        };
      }catch(err){
        console.log(err,"不支持find方法");
      }
    }
    if(appweb){
      appwebPage=appweb;
    }
    return appwebPage;
  }
    /**
   * 过滤掉页面模块/字段权限数据节点
   */
  private GetFieldPageConfig(key:string):Data{
    let appwebPage:Data=null;
    let appweb=this.GetStorageKey("pagemode");//模块权限过滤
    if(appweb){
      let appfieldpersion=appweb[key];
      if(appfieldpersion){
        let searchList=appfieldpersion;
        if(searchList){
          appwebPage=searchList;
        }
      }
      
    }
    return appwebPage;
  }
  /**
   * 获取对应的页面配置列表文件
   * @param Key 表示当前页面的名称，类似于后端对应的xml的ConfigName值。
   * @param isfieldpersion:表示是否权限过滤的数据源，默认所有数据false
   */
  GetPageConfigKey(Key:string,isfieldpersion:boolean=false):Data{
   //console.log(1001011);
    let allpageConfigweb:Data=null;
       let pageList:Array<AppPageConfig>=null;
        pageList=this.GetAllPageConfig(Key);
        pageList.forEach((items,keyindex)=>{
          if(items.Key){
            if(items.Key.toLowerCase()===Key.toLowerCase()){
              if(items.Data){
                allpageConfigweb=items.Data;
                allpageConfigweb=this.PageModalOrPermission(items.Data,Key);
              }
            }
          }
        });
        // let list=pageList.find((items)=>items.Key ===Key);
        // if(list){
        //   let AllList=pageList.find((items)=>items.Key===Key).Data;
        //   if(AllList){
        //     allpageConfigweb=AllList;
        //     allpageConfigweb=this.PageModalOrPermission(AllList,Key);
        //   }
        // }
       return allpageConfigweb;
  }
  /**
   * 
   * @param data 存储临时数据
   */
  SetTempPageMode(data:any){
     let pageconfigmodel=JSON.parse(localStorage.getItem("temppagemode"));
     if(pageconfigmodel){
     }else{
       localStorage.setItem("temppagemode",JSON.stringify(data));
     }
  }
  /**
   * 获取临时
   * @param configName 获取当前xml名称
   */
  GetTempPageModeKey(configName:string){
    let data = null;
    let pagemodel=JSON.parse(localStorage.getItem("temppagemode"));
    if(pagemodel){
      data = pagemodel;
    }
    return data;
  }
  /**
   * PG信息数据
   */
  get getPGInfo(){
    let pginfo = this.GetStorageKey("pginfo");
    if(pginfo){
      return pginfo;
    }else{
      return {};
    }
  }
  /**
   * 获取token值
   */
  get getToken():Token{
    let apptoken:Token;
    let apptokeninfo=localStorage.getItem("token");
    if(apptokeninfo){
      apptoken=JSON.parse(apptokeninfo);
    }
    return apptoken;
  }
  /**
   * 判断角标是否完成，返回bool类型；默认 true
   * @param pangeName 当前页面的pagename;
   */
  getBadge(pangeName:any){
    const that = this;
    let isbadge:boolean=true;
    //先判断是否必填/或者设置上班可操作时有效
    let homeArray:Array<any> = that.GetStorageKey("badge_"+that.GetAccount.Id);
    ////console.log(homeArray);
    const PageName = pangeName;
    if(homeArray){
    const newArraYList:any=homeArray.find(items=>items.pageName.trim().toLowerCase()==PageName.trim().toLowerCase());
    if(newArraYList){
      newArraYList.temps.forEach(temp=>{
        temp.btns.forEach(btn=>{
          if(btn.employLimit=="work"){
            if(btn.required && !btn.state){
              isbadge=false;
            }
          }else{
            if(btn.required && !btn.state){
              isbadge=false;
            }
            
          }
          // if((btn.required && !btn.state)||(btn.employLimit=="work")){
          //   isbadge=false;
          // }
        });
     });
    }
   
  }
  return isbadge;
}
/**
 * 更改角标数据，完成/未完成及时更新
 * @param pageName 当前页面的pageName
 * @param btnName 更改的按钮Name
 */
setBadge(pageName:any,templateName:any,btnName:any){
  const that = this;
   //先判断是否必填项未完成
  //  //console.log(1101);
   let badgeArray:Array<any> = that.GetStorageKey("badge_"+that.GetAccount.Id);
   if(badgeArray){
    const addArraYList:any=badgeArray.find(items=>items.pageName.trim().toLowerCase()==pageName.trim().toLowerCase());
    if(addArraYList){
       let addList:any=addArraYList.temps.find(titem=>titem.tempName.trim().toLowerCase()==templateName.trim().toLowerCase());
       if(addList){
        addList.btns.forEach(btn=>{
          if(btn.btnName.trim().toLowerCase()==btnName.trim().toLowerCase()){
              btn.state+=1;
          }
        });
       }
    }
   }
   localStorage.setItem("badge_"+that.GetAccount.Id,JSON.stringify(badgeArray));
// console.log(badgeArray);
}
  /**
   * 获取浏览器名称
   */
  get BrowserRedirect():string{
    let mobileType="";
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i);
    let bIsIphoneOs = sUserAgent.match(/iphone os/i);
    let bIsMidp = sUserAgent.match(/midp/i);
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
    let bIsUc = sUserAgent.match(/ucweb/i);
    let bIsAndroid = sUserAgent.match(/android/i);
    let bIsCE = sUserAgent.match(/windows ce/i);
    let bIsWM = sUserAgent.match(/windows mobile/i);
    let weixin=sUserAgent.match(/MicroMessenger/i);//微信
    if (bIsIpad || bIsIphoneOs) {
        mobileType="maxos";
    }else if(weixin){
      mobileType="weixin";
    } 
    else {
        mobileType="pc";
    }
    return mobileType;
  }
   /**
   * 返回上一个页面
   * @param isRefresh 是否刷新上一个页面，默认刷新,default:true
   */
  goBack(isRefresh:boolean=false){
    const that =this;
    // isRefresh=true;
    console.log("backlouut.....");
    let arrayList:Array<any>=[];
    let urltemp:any ="";
    if(localStorage.getItem("backurl")){
      arrayList = that.GetStorageKey("backurl")||[];// JSON.parse(localStorage.getItem("backurl"));
      if(arrayList.length>0){
            urltemp= arrayList[arrayList.length-1];
            if(urltemp.indexOf('[Refresh]')>=0){//表示是不刷新页面则主动设置isRefresh为false
              isRefresh = false;
            }
            if(urltemp.indexOf('[Isfresh]')>=0){
              isRefresh = true;
            }
            urltemp=urltemp.replace("[Refresh]","");
            urltemp=urltemp.replace("[Isfresh]","");
            arrayList.splice(arrayList.length-1,1);
            localStorage.setItem("backurl",JSON.stringify(arrayList));
            // if(urltemp.indexOf(that.getHonmeUrl().Component)>=0){//如果是首页则直接跳转
            //   that.GoUrl("/tabs/" + that.getHonmeUrl().Url+"/"+that.getNowDatetime);
            //   return;
            // }
            if(isRefresh){//如果刷新页面,添加时间戳
              if(urltemp.indexOf("?")>=0){
                let _urltemp:any = urltemp.split("?");
                if(_urltemp[0].split('/').length==2){
                  that.GoUrl(_urltemp[0]+'/'+that.getNowDatetime+"?"+_urltemp[1]);
                }else{
                  if(_urltemp.indexOf('&')=="-1"){
                    if(_urltemp.indexOf("login")>=0){
                      that.GoUrl(urltemp);
                    }else{
                      that.GoUrl(_urltemp[0]+'&'+that.getNowDatetime+"?"+_urltemp[1]);
                    }
                  }else{
                    that.GoUrl(_urltemp+that.getNowDatetime+"?"+_urltemp[1]);
                  }
                }
              }else
              if(urltemp.split('/').length==2){
                that.GoUrl(urltemp+'/'+that.getNowDatetime);
              }else{
                if(urltemp.indexOf('&')=="-1"){
                  if(urltemp.indexOf("login")>=0){
                    that.GoUrl(urltemp);
                  }else{
                    that.GoUrl(urltemp+'&'+that.getNowDatetime);
                  }
                }else{
                  that.GoUrl(urltemp+that.getNowDatetime);
                }
                
              }
            }else{
              that.GoUrl(urltemp);
            }
             console.log(urltemp,"返回地址");
      }else{
        console.log("进入五页面");
        // that.navctr.pop();
        that.GoUrl("/tabs/" + that.getHonmeUrl().Url+"/"+that.getNowDatetime);
      }
   
    }else{
      console.log("进入pop页面");
      // that.navctr.pop();
      that.GoUrl("/tabs/" + that.getHonmeUrl().Url+"/"+that.getNowDatetime);
     
    }

  }
  /**
   * 移除返回
   */
  removeBack(){
    let arrayback:Array<any> = [];
    if(localStorage.getItem("backurl")){
      arrayback = this.GetStorageKey("backurl")||[];
      if(arrayback.length>1){//判断缓存几个url地址
         arrayback.splice(arrayback.length-1,1);
      }
      localStorage.setItem("backurl",JSON.stringify(arrayback));
    }
  }
  /**
   * 获取当前页面地址
   * @param isRefresh 存取地址时，判断是否返回时刷新当前页面,默认为"true"刷新
   */
  setHistoryUrl(isRefresh:boolean=true){
    let that = this;
    // debugger;
    // if(that.IsWeixinBrowser){
    //   let state:any = {
    //     title: "",
    //     url: "/"
    // };  
    // window.history.pushState(state, state.title, state.url);  
    // }
    // isRefresh=true;
    let locationback:Array<any>=[];
    if(localStorage.getItem("backurl")){
       locationback = that.GetStorageKey("backurl")||[];//    JSON.parse(localStorage.getItem("backurl"));
    }
    // debugger;
    //console.log("地址对比");
    if(that.platformlocation["location"].hash.replace('#','')){
      const backurl:any =that.platformlocation["location"].hash.replace('#','');
      // const isMainMenu = this.getHonmeUrl().Component;//获取主菜单地址
      // if(backurl.indexOf(isMainMenu)>=0){
      //   return;
      // }
      const newurl:any = locationback[locationback.length-1];
      let historyUrl=that.platformlocation["location"].hash.replace('#','');
      if(!isRefresh){//不刷新时处理
        historyUrl=historyUrl+"[Refresh]";
      }else
      {
        historyUrl=historyUrl+"[Isfresh]";
      }
      if(newurl && backurl){
        if(newurl.indexOf('&')!="-1" && backurl.indexOf('&')!="-1"){//表示有时间戳
          const _strurl=newurl.substring(0,newurl.lastIndexOf('/'));
          const _newurl=backurl.substring(0,backurl.lastIndexOf('/'));
          if(_strurl!=_newurl){
            locationback.push(historyUrl);
          }
        }else{
          locationback.push(historyUrl);
        }
      }else{
        locationback.push(historyUrl);
      }
    }
    localStorage.setItem("backurl",JSON.stringify(locationback));
  }
  /**
   * 坐标距离计算
   * @param lng  开始纵坐标
   * @param lat 开始横坐标
   * @param endlng 结束纵坐标
   * @param endlat 结束横坐标
   */
  Dist(lng, lat, endlng, endlat):any 
  {
    if (lng > 0 && lat > 0 && endlng > 0 && endlat > 0) {
          let sqlnumber:number = 6378137 * 2 * Math.asin(
            Math.sqrt(
                Math.pow(Math.sin((lat - endlat) * Math.acos(-1) / 360), 2)
                + Math.cos(lat * Math.acos(-1) / 180)
                * Math.cos(endlat * Math.acos(-1) / 180)
                * Math.pow(Math.sin((lng - endlng) * Math.acos(-1) / 360), 2)
            )
        );
        if(sqlnumber < 0){
          sqlnumber = 0;
        }
        return sqlnumber;
    }
    else {
        return 0;
    }
  
  }
  /**
   * 
   * @param data 二维码数据
   */
 
goQrCode(data:string,type:string="二维码",title:string="二维码"){
  const param = encodeURIComponent(data);
  const _type = encodeURIComponent(type+"&"+title);
  // this.router.navigate(['/tabs/qrcode/'+_type+"/"+param+"&"+this.getNowDatetime]);
  this.Go('/tabs/qrcode/'+_type+"/"+param+"&"+this.getNowDatetime);
  }
  goQrCodeone(data:string,type:string="二维码",title:string="二维码"){
    console.log("新方法 下hi i行了")
    const param = encodeURIComponent(data);
    const _type = encodeURIComponent(type+"&"+title);
    // this.router.navigate(['/myqrcode/'+_type+"/"+param+"&"+this.getNowDatetime]);
    this.Go('/myqrcode/'+_type+"/"+param+"&"+this.getNowDatetime);
    }

  /**
   * 判断是否正整数
   * @param str 需要输入的值
   */
  isNumber(str:any){
    const code = new RegExp("^[0-9]*$");
    const maxNum:number =Number.parseInt(app.NUM);
    // console.log(code.test(str));
    let codeNum:number=0;
    if(code.test(str)){
      codeNum=Number.parseInt(str);
      if(codeNum>maxNum){
        return false;
      }else{
        return true;
      }
      
    }else{
      return false;
    }
  }
   /**
   * 验证是否正整数，并且返回数字，或者null
   * @param str 需要输入的值
   */
  GetNumber(str:any){
    const code = new RegExp("^[0-9]*$");
    const maxNum:number =Number.parseInt(app.NUM);
    let codeNum:number=0;
    // console.log(str);
    if(code.test(str)){
          codeNum=Number.parseInt(str);
      let strnum = codeNum;
      if(codeNum>maxNum){
        let maxlength:number =maxNum.toString().length; 
        codeNum = Number.parseInt(strnum.toString().substring(0,maxlength));
      }
      return codeNum;
    }else{
      return null;
    }
  }
  /**
   * 判断小数点后两位小数
   * @param str  需要输入的值
   */
  isDouble(str:any){
    const code =/^(([1-9][0-9])|(([0].\d{0,2}|[1-9][0-9].\d{0,2})))$/;
    // console.log(code.test(str));
    return code.test(str);
  }
/**
 * 正则表达式判断可以输入负数整数
 * @param value 输入的值
 */
isFloat(value){
  // let re = /^-?[1-9]*(\.\d*)?$|^-?0(\.\d*)?$/;//正则表达式判断可以输入负数整数
  let pattern = /^(\-|\+)?\d+(\.\d+)?$/;//正则表达式判断可以输入负数整数
  console.log("负数");
  return pattern.test(value);
}
/**
 * 判断整数负整数
 * @param value 当前输入的值
 */
isNumberFloat(value){
  let root:boolean = false;
  let pattern=/^-[1-9]\d*$/;//负整数
  let patterns=/^[1-9]\d*$/;//整数
  if(pattern.test(value) || patterns.test(value)){
    root=true;
  }
  return root;
}
  /**
   * 保存当前页面的查询条件
   * @param obj 页面保存的筛选条件
   */
  SaveSearchInfo(obj:any){
    let _arr = this.GetStorageKey("searchArray") || [];
    let _isAdd = false;
    // _arr.forEach(item=>{
    //   if(item.pageName == obj.pageName){
    //     item = obj;
    //     _isAdd = true;
    //   }
    // })
    for(let i =0;i < _arr.length;i++){
      if(_arr[i].pageName == obj.pageName){
        _arr[i] = obj;
        _isAdd = true;
      }
    }
    if(!_isAdd){
      _arr.push(obj);
    }
    localStorage.setItem("searchArray",JSON.stringify(_arr));
  }

  /**
   * 盘库日期限制
   */
  InventoryDatelimit(){
    const day = new Date().getDate();
    let limitArr = app.Inventory.split(",");
    let isSubmit = false;
    limitArr.forEach(item=>{
      if(day == item){
        isSubmit = true;
      }
    })
    let _obj = {
      isSubmit:isSubmit,
      begin:limitArr[0] || 0,
      end:limitArr[limitArr.length - 1] || 0
    }
    return _obj;
  }
   /**
  * debug 输出模式
  * @param message 文本内容
  */
 Log(message:any){
  if(app.DEBUG){
    console.log(message);
  }

}
 /**
   * 格式化年份
   * @param nowYear 
   */
  get FormatYear () {
    let now = new Date();
    let nowYear = now.getFullYear();
      var arr = [];
      for (var i = nowYear - 5; i <= nowYear + 10; i++) {
          arr.push({
              id: i + '',
              value: i + '年'
          });
      }
      return arr;
  }
  /**
   * 格式化月份
   */
  get FormatMonth () {
    var arr = [];
    for (var i = 1; i <= 12; i++) {
        arr.push({
            id: i + '',
            value: i + '月'
        });
    }
    return arr;
  }
  /**
   * 格式化天数
   * @param count 
   */
  FormatDate (count) {
    var arr = [];
    for (var i = 1; i <= count; i++) {
        arr.push({
            id: i + '',
            value: i + '日'
        });
    }
    return arr;
  }
  FormatDateData(type:any,data:string=""){
    let timeDate:Array<any>=new Array<any>();
    let resultData:Array<any> = new Array<any>();
    if(data.indexOf("-")>=0){
      timeDate = data.split("-");
    }else if(data.indexOf("/")>=0){
      timeDate = data.split("/");
    }else if(data.indexOf(":")>=0){
      timeDate = data.split(":");
    }
    switch(type){
      case "yyyymmdd"://年月日
      timeDate.forEach(item=>{
        if(item.indexOf(":")>=0){
          if(item.split(" ")[0]){
            resultData.push(Number.parseInt(item.split(" ")[0]));
          }
        }else{
          if(item){
            resultData.push(Number.parseInt(item));
          }
        }
      });
    break;
    case "yyyymm"://年月
    // debugger;
    timeDate.forEach(item=>{
      resultData.push(Number.parseInt(item));
    });
    break;
    case "hhmmss"://时分秒
    timeDate.forEach(item=>{
      if(item.indexOf(":")>=0){
        let temparray:any;
        if(item.split(" ").length>0){
          temparray = item.split(" ")[1];
          temparray.split(":").forEach(temp=>{
            resultData.push(Number.parseInt(temp));
          });
        }
      }else{
        resultData.push(Number.parseInt(item));
      }
    });
      break;
      case "hhmm"://时分
      ////console.log(timeDate);
      timeDate.forEach(item=>{
        if(item.indexOf(":")>=0){
          let temparray:any;
          if(item.split(" ").length>0){
            temparray = item.split(" ")[1];
            let hhtemp = temparray.split(":");
            for(let i=0; i<hhtemp.length-1;i++){
              resultData.push(Number.parseInt(hhtemp[i]));
            }
          }
        }else{
          resultData.push(Number.parseInt(item));
        }
      });
      break;
      case "default"://时分
      case "yyyymmddhhmmss"://时分
      timeDate.forEach(item=>{
        if(item.indexOf(":")>=0){
          let temparray:any;
          if(item.split(" ").length>0){
            resultData.push(item.split(" ")[0]);
            temparray = item.split(" ")[1];
            temparray.split(":").forEach(temp=>{
              resultData.push(Number.parseInt(temp));
            });
          }
        }else{
          resultData.push(Number.parseInt(item));
        }
      });
      break;
    }
    return resultData;
  }
  /**
 * 计算小时
 * @param one 
 * @param two 
 * @param three 
 */
get GetHourData(){
  var hours = [];
  for (var i = 0,len = 24; i < len; i++) {
      hours.push({
          id: i,
          value: i + '时'
      });
  }
  return hours;
}
/**
 * 计算分
 * @param one 
 * @param two 
 * @param three 
 * @param four 
 */
get GetMinuteData(){
  var minutes = [];
  for (var i = 0, len = 60; i < len; i++) 
  {
      minutes.push({
          id: i,
          value: i + '分'
      });
  }
  return minutes;
}  
/**
 * 计算秒
 */
get GetSecondsData(){
  var seconds = [];
  for (var i = 0, len = 60; i < len; i++) {
      seconds.push({
          id: i,
          value: i + '秒'
      });
  }
  return seconds;
 } 
 /**
  * 判断当前手机系统版本是否小于5.0
  */
 get Isandroidversion(){
  const that =this;
  let isplatform:boolean = false;
  if(that.platform.is("cordova")){
    if(that.platform.is("android")){
      if(that.device.version){
        // if(that.device.version.toString().startsWith("5")){
        //   isplatform=true;
        // }else 
        if(that.device.version.toString().startsWith("4")){
          isplatform=true;
        }else if(that.device.version.toString().startsWith("3")){
          isplatform=true;
        }else if(that.device.version.toString().startsWith("2")){
          isplatform=true;
        }
      }
     }
  }
  return isplatform;
 }
     /**
   * 获取当前时间不包含时分秒并且小于10不会添加零
   */
  get getNows(){
    let date:Date = new Date();
    // ////console.log(1001011);
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any =  date.getDate();
   month=tmp1;
   day = tmp2;
   year = riqi;
    return year+"-"+month+"-"+day;
  }
  /**
   * 当前年加10年
   */
  get TenTime(){
    let date:Date = new Date();
    let _y = date.getFullYear()+10;
    let _m:any = date.getMonth()+1;
    let _mt:string=_m.toString();
    if(_m<10){
      _mt="0"+_m;
    }
    let _d:any =  date.getDate();
    let _ym:string=_d.toString();
    if(_d<10){
      _ym="0"+_d;
    }
    return _y+"-"+_mt+"-"+_ym;
  }

  getGradeCode(code:string){
    if(!code){
      return 0;
    }
    switch(code){
      case "D000":
        return 0;
      case "D001":
        return 1;
      case "D002":
        return 2;
      case "D003":
        return 3;
      default:
        return 0;
    }
  }
  /**
 * 初始化项目数据
 */
initLoad(fileName:any = "a2.json"):Promise<any>{
  const that =this;
    return  new Promise<any>((resolve,reject)=>{
      //判断当前是否真机
        let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
        if(that.platform.is("android")){
          tempDirectory=that.file.externalCacheDirectory;//android
        }
          try{
            if(!that.platform.is("android")){//ios直接替换文件
              resolve("ios");
            }else{
                   //判断手机目录是否存在数据库文件,存在的话直接输出
                   that.file.readAsText(tempDirectory,fileName).then(a2Data=>{
                    console.log("文件存在");
                    // if(JSON.parse(a2Data)){
                    //   let body = JSON.parse(a2Data);
                    //   that.SetAllPageConfig(body);
                    // }
                    resolve(a2Data);
                  }).catch(err=>{
                    console.log("文件不存在");
                    console.log(that.file.applicationDirectory);
                    console.log(that.file.applicationStorageDirectory);
                  let fileUrl=that.file.applicationDirectory+"www/assets";//"file:///android_asset/www/assets
                  //不存在,拉取app程序本地文件
                  that.file.readAsText(fileUrl,"All.json").then(all=>{
                    console.log("读取文件成功");
                        let alljson =JSON.parse(all);
                        // that.SetAllPageConfig(alljson);
                        that.file.writeFile(tempDirectory,fileName,JSON.stringify(alljson),{replace:true}).then(data=>{
                          console.log("写入文件成功");
                            console.log(data);
                        }).catch(err=>{
                          console.log("写入文件失败");
                            console.log(err);
                        });
                        resolve(all);
                    }).catch(err=>{
                      console.log("读取文件失败");
                        console.log(err);
                        reject(err);
                    });
                  });
            }
          }catch(err){
            console.log("try");
            reject(err);
          }
    });
}
  /**
 * 保存文件到手机临时目录,默认保存在 externalCacheDirectory目录
 * @param stringContent 需要保存的数据对象，必须是string类型数据，否则保存失败
 * @param fileName 需要保存的文件名称以及类型,默认"a2.json"
 */
WriteFile(stringContent:any,fileName:any="a2.json"):Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reject)=>{
    //判断当前是否真机
    if(that.platform.is("cordova")){
      let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
      console.log(tempDirectory);
      if(that.platform.is("android")){
        tempDirectory=that.file.externalCacheDirectory;//android
      }
      try{
           console.log("保存文件之前","单文件");
           that.file.writeFile(tempDirectory,fileName,stringContent,{replace:true}).then(data=>{
            console.log(data);
            resolve(data);
          }).catch(err=>{
              console.log(err);
              reject(err);
          });
      }catch(err){
        reject(err);
      }
    }else{
      reject("非真机环境");
    }
  });
}
/**
 * 保存文件到手机临时目录,如果文件存在则合并数据；默认保存在 externalCacheDirectory目录
 * @param stringContent 需要保存的数据对象，必须是string类型数据，否则保存失败
 * @param fileName 需要保存的文件名称以及类型,默认"a2.json"
 */
WriteExistingFile(stringContent:any,fileName:any="a2.json"){
  const that=this;
  return new Promise<any>((resolve,reject)=>{
    //判断当前是否真机
    if(that.platform.is("cordova")){
      let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
      if(that.platform.is("android")){
        tempDirectory=that.file.externalCacheDirectory;//android
      }
      try{
           console.log("保存文件之前","多文件");
          that.file.readAsText(tempDirectory,fileName).then(fileData=>{//P判断当前文件是否存在,并判断时候有值
            let tempobj:Array<any> = new Array<any>();
            let arrayobj:any=JSON.parse(fileData);
            if(arrayobj.constructor==Array){
              tempobj = arrayobj;
            }else{
              tempobj.push(arrayobj);
            }
            let temp = JSON.parse(stringContent);
                 tempobj.push(temp);
            that.WriteFile(JSON.stringify(tempobj),fileName).then(data=>{
              console.log(data);
              resolve(data);
            }).catch(err=>{
                console.log(err);
                reject(err);
            });
          }).catch(err=>{
            that.WriteFile(stringContent,fileName).then(data=>{
              console.log(data);
              resolve(data);
            }).catch(err=>{
                console.log(err);
                reject(err);
            });
          });
      }catch(err){
        reject(err);
      }
    }else{
      reject({"error":"非真机环境"});
    }
  });
}
/**
 * 获取指定文件夹下所有的文件以及目录
 * @param path 手机上真实的目录地址
 * @param dirName 文件或者目录名称
 */
GeAllFieldsList(path:string="",dirName:string=""):Promise<any>{
  const that =this;
  return new Promise<any>((resolve,reject)=>{
   //判断当前是否真机
   if(that.platform.is("cordova")){
      path=that.file.tempDirectory;//默认ios临时目录
    if(that.platform.is("android")){
      path=that.file.externalCacheDirectory;//android
    }
     that.file.listDir(path,dirName).then(data=>{
      resolve(data);
       console.log(data);
     }).catch(err=>{
      reject(err);
      console.log(err);
     });
   }else{
    reject("必须真机测试");
   }
  });
}
/**
 * 计算localStorage剩余大小(kb)
 */
getStorageSize(){
  var size = 0;
  for(let item in window.localStorage) {
      if(window.localStorage.hasOwnProperty(item)) {
          size += window.localStorage.getItem(item).length;
      }
    }
    return (size / 1024).toFixed(2) + 'KB';
  }
  /**
 * 获取缓存中需要的配置项
 */
GetStaticObject(){
  let data:Array<any> = this.GetStorageKey("StaOb") || [];
  if(data){
    data.forEach((e,index)=>{
        if(e.a_Code){
          if(e.a_Code=="WEBSITE"){//处理所有常量关联域名问题处理
                 if(localStorage.getItem("WEBSITE")){
                  e.a_Value=localStorage.getItem("WEBSITE");
                 }
            this.getWebSetApp("WEBSITE",e.a_Value);
         }else if(e.Code=="WEBURL"){
             this.getWebSetApp("WEBURL",e.a_Value);
         }else{
              app[e.a_Code]=e.a_Value;
          }
      }
    });
  }
}
/**
   * 测试切换时域名切换回来问题
   */
  getAppsetting(){
    const that =this;
  if(!that.GetStorageKey("StaOb")){
      that.loadScript("assets/appsettings.js",function(load){console.log(load)});
      return;
    }else{
      let arrayListNew:Array<any> = that.GetStorageKey("StaOb");
      arrayListNew.forEach((El,index)=>{
          if(El.a_Code=="WEBSITE" && El.a_Value){
              that.getWebSetApp("WEBSITE",El.a_Value);
          //   app.WEBSITE=El.a_Value;
          }
      });
    }
}
/**
 * 更具后端配置切换本地配置文件数据
 */
getAppConfig(appArray:Array<any>=[]){
      appArray.forEach((e,index)=>{
          if(e.a_Code){
              if(e.a_Code=="WEBSITE"){//处理所有常量关联域名问题处理
                 this.getWebSetApp("WEBSITE",e.a_Value);
              }else if(e.a_Code=="WEBURL"){
                  this.getWebSetApp("WEBURL",e.a_Value);
              }
              else{
                  app[e.a_Code]=e.a_Value;
              }
          }
  });
}
/**
 * 修改域名多处使用地方处理
 * @param appName 当前域名的key
 * @param value 对应的value值
 */
getWebSetApp(appName:string,value:string){
    let app_value = app[appName];
    for(let key  in app){
      if(key=="WEBSITE" || key=="WEBURL"){

      }else{
      if(typeof(app[key])=="string")
      {
          if(app[key]){
              if(key!=appName){
                  app[key]=app[key].replace(app_value,value);
              }
          }
      }
    }
      // console.log(key + '---' + app[key]);          
    }
  app[appName]=value;
}
    /**
     * 动态加载js文件
     * @param src  文件路劲
     * @param callback 返回值
     */
    loadScript(src, callback) {
      let script = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.src = src;
      if (script.addEventListener)
      {
        script.addEventListener('load', function () {
          callback();
        }, false);
      }
      head.appendChild(script);
    }
    /**
     * 遍历数组数据获取当前页面权限数据对象以及整个框架结果数据
     * @param data 
     */
    JurisdictionArrayList(data:any,xmlconfigName:string):Array<any>{
      console.log(data,"数据");
      let bw:Array<any> = new Array<any>();
      let juest:any={"xml":null,"all":[]};
      data.forEach(el=>{
        if(el["Key"]==xmlconfigName){
          juest.xml = this.GetPageConfigData(el,xmlconfigName);
         }
      });
     juest.all=data;
      return juest;
    }
      /**
   * 获取对应的页面配置列表文件
   * @param page 表示当前页面配置。
   * @param key 表示当前页面configName。
   */
  GetPageConfigData(page:any,Key:string):Data{
    //console.log(1001011);
     let allpageConfigweb:Data=null;
     if(page.Data){
      allpageConfigweb=page.Data;
      allpageConfigweb=this.PageModalOrPermission(page.Data,Key);
    }
   return allpageConfigweb;
   }
      /**
    * 去除特殊字符
    * @param str 
    */
   GetChineselanage(str:string=""){
     if(!str){
      str="";
     }
    let ar:Array<string> = app.Special.split(',');
    ar.forEach(chart=>{
      str=str.replace(new RegExp(chart,'g'),"");
    });
    return str;
   }
   /**
    * 获取GUID,app端返回的是数据库对应的guid,例如:'1212f4f6-8d91-4534-a20c-87aed2c3c90f',网页端返回的是时间格式;例如:'201911041211455'
    */
   GUID():Promise<string>{
     const that =this;
     return new Promise<string>((reject,resolve)=>{
       let getNowDate:string = that.getNowDatetime;
       console.log(getNowDate);
      if(that.platform.is("cordova")){
        if(that.platform.is("android")){
          try{
            cordova.plugins.camera.GUID("get GUID",function(data){
              reject(data);
            },function(err){
              reject(getNowDate);
            });
          }catch(err){
            reject(getNowDate);
          }
        }else{
          reject(getNowDate);
        }
      }else{
        reject(getNowDate);
      }
     });
   }
   /**
    * 文件类型 默认为:".pdf"
    * @param key 当前文件的后缀名称，默认:".pdf"
    */
   ContentType(key:string=".pdf"){
     const that=this;
     let contentType:any={
      ".mp4":"video/mp4",
      ".wmv":"video/x-ms-wmv",
      ".pdf":"application/pdf",
      ".xml":"application/xml",
      ".zip":"application/zip",
      ".ppt":"application/x-ppt"
      };
        console.log(".pdf","文件类型");
        /**
         * 获取后端返回的配置文件
         */
        if(app["MIME"]){
          contentType = Object.assign(contentType,app["MIME"]);
        }
      let defaultobj:any = that.GetStorageKey("StaOb");
      if(defaultobj){
        if(defaultobj["MIME"]){
              app["MIME"]=defaultobj["MIME"];
          contentType = Object.assign(contentType,defaultobj["MIME"]);
        }
      }
      let fileType:any="application/pdf";
          fileType=contentType[key];
      return fileType;
   }
    /**
   * 判断微信是否支持
   */
  get IsWeixinBrowser(){
    var ua = navigator.userAgent.toLowerCase();  
    var result = (/micromessenger/.test(ua)) ? true : false;
    if (result) {
        console.log('你正在访问微信浏览器');
    }
    else {
        console.log('你访问的不是微信浏览器');
    }
    return result;
  }
  /**
   * 判断是否来自微信浏览器并且是android；
   */
  get isWeixinAndroid(){
    if(this.IsWeixinBrowser){
      if (/android/i.test(navigator.userAgent))
      {
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }
  /**
   * 判断是否来自微信浏览器并且是IOS；
   */
  get isWeixinIOS(){
    if(this.IsWeixinBrowser){
      if (/ipad|iphone|mac/i.test(navigator.userAgent))
      {
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }
    /**
   * 微信端关闭程序方法
   */
   CloseWeixin(){
     wx.closeWindow();
  }
/**
 * 微信请求接口配置,调用微信wx.config方法
 */
  WXConfig():Promise<WebResponesContext>{
    const that=this;
    return new Promise<WebResponesContext>((resolve,reject)=>{
      let msg:WebResponesContext=new WebResponesContext();
      let  wxfg:any = that.GetStorageKey("wxconfig");
      if(wxfg){
       let _newwxconfig = that.base.WxConfig;
             wxfg.config.debug=app.DEBUG;//是否关闭debug模式
       let _wxconfig:any =Object.assign(_newwxconfig,wxfg.config);
       msg.ResponseMessage.Success=true;
       try{
        wx.config(_wxconfig);
        wx.ready(function(e){
          console.log(e,"ready");
          setTimeout(()=>{
           resolve(msg);
          },600);
         });
         wx.error(function(res){
           msg.ResponseMessage.Success=false;
           msg.ResponseMessage.ErrorCode=63002;
           msg.ResponseMessage.ErrorMessage=JSON.stringify(res);
           console.log(res.errMsg,"微信失败");
           if(res.errMsg.indexOf("config:fail")!=-1){
            msg.ResponseMessage.ErrorMessage=JSON.stringify(res);//"微信授权失败，请联系管理员";
           }
            reject(msg);
         });
       }catch(err){
        msg.ResponseMessage.Success=false;
        msg.ResponseMessage.ErrorCode=63002;
        msg.ResponseMessage.ErrorMessage=err;
         reject(msg);
       }
      }else{
        msg.ResponseMessage.Success=false;
        reject(msg);
      }
    });
  }
  /**
   * 
   * @param corpid 必填，企业微信的corpid，必须与当前登录的企业一致
   * @param agentid 必填，企业微信的应用id
   * @param timestamp 必填，生成签名的时间戳
   * @param nonceStr 必填，生成签名的随机串
   * @param signature 必填，签名
   * @param jsApiList 必填，权限列表
   */
  AgentConfig(corpid:string,agentid:string,timestamp:number,nonceStr:string,signature:string,jsApiList:Array<string>=[]):Promise<WebResponesContext>{
    const that=this;
    return new Promise<WebResponesContext>((resolve,reject)=>{
      let msg:WebResponesContext=new WebResponesContext();
       msg.ResponseMessage.Success=true;
       console.log("授权开始");
       wx.agentConfig({
        corpid: corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: agentid, // 必填，企业微信的应用id
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature,// 必填，签名，见附录1
        jsApiList: jsApiList, //必填
        success: function(res) {
            // 回调
            console.log(res,"successresult");
            console.log("agentConfig，success回调成功");
            resolve(msg);
        },
        fail: function(res) {
          console.log(res,"fail");
            if(res.errMsg.indexOf('function not exist') > -1){
              res.errMsg="版本过低请升级";
            }
            msg.ResponseMessage.Success=false;
            msg.ResponseMessage.ErrorCode=63002;
            msg.ResponseMessage.ErrorMessage=JSON.stringify(res);
             console.log(res,"微信失败");
             reject(msg);
        }
        });
    });

  }
  /**
   * 授权登录
   * @param params 授权参数
   */
  AgentConfigWechat(params: AgentConfigParams): Promise<WebResponesContext> {
    const that = this;
    let isagent:boolean=false;//判断是否权限无法认证。
    return new Promise<WebResponesContext>((resolve, reject) => {
      let msg: WebResponesContext = new WebResponesContext();
      msg.ResponseMessage.Success = true;
      wx.agentConfig({
        corpid: params.Corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: params.Agentid, // 必填，企业微信的应用id
        timestamp: params.Timestamp, // 必填，生成签名的时间戳
        nonceStr: params.NonceStr, // 必填，生成签名的随机串
        signature: params.Signature,// 必填，签名，见附录1
        jsApiList: params.JsApiList, //必填
        success: function (res) {
          isagent=true;
          // 回调
          console.log("agentConfig，success回调成功");
          resolve(msg);
        },
        fail: function (res) {
          isagent=true;
          if (res.errMsg.indexOf('function not exist') > -1) {
            res.errMsg = "版本过低请升级";
          }
          msg.ResponseMessage.Success = false;
          msg.ResponseMessage.ErrorCode = 63002;
          msg.ResponseMessage.ErrorMessage = JSON.stringify(res);
          console.log(res, "微信失败");
          reject(msg);
        }
      });
      let timeout=setTimeout(()=>{
        console.log(isagent,"授权timeout");
        if(isagent){
          clearTimeout(timeout);
        }else{
          resolve(msg);
        }
      },3000);
    });
  }
  /**
   * 手机号码中间变成****
   * @param str 当前手机号码
   * @param isreplace 是否电话号码变成*号 默认是true
   */
  PhoneNum(str:any,isreplace:boolean=true){
    if(isreplace){
      return str.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2");
    }else{
      return str;
    }
  }
  /**
   * 格式化姓名(如果两个字 最后一个字加“*”，三个字以及以上中间字加"*"")
   * @param name 姓名
   * @param isreplace 是否姓名中间添加*号，默认  true
   */
  FormatName(name:string,isreplace:boolean=true){
    let newStr;
    if(isreplace){
      let cn = /^[\u4e00-\u9fa5]+$/;//判断是否汉字的正则表达式
      if(cn.test(name)){
        if (name.length === 2) {
          newStr = name.substr(0, 1) + '*';
          } else if (name.length > 2) {
            let char = '';
            for (let i = 0, len = name.length - 2; i < len; i++) {
              char += '*';
            }
            newStr = name.substr(0, 1) + char + name.substr(-1, 1);
          } else {
            newStr = name;
          }
      }else{//包含英文以及数字
        if (name.length === 2) {
          newStr = name.substr(0, 1) + '*';
        }else if(name.length > 2){
          let char = '';
            for (let i = 0, len = name.length - 2; i < len; i++) {
              char += '*';
            }
            newStr = name.substr(0, 1) + char + name.substr(-1, 1);
        }else{
          newStr=name;
        }
      }
    }else
    {
      newStr=name;
    }
    return newStr;
  }

  /*
  会员信息的  会员标签公用方法
  */
   CustomerTag(element:any=AppSelectItems,objfield:any={},arrType:any=[])
   {
    // if(element.formatter && element.formatter == "type"){
    //   if(objfield[element.bindingField].value&&objfield[element.bindingField].value){
    //     if(element.bindingField=="type1"&&objfield[element.bindingField].value)
    //     {
    //       arrType.push(element.text);
    //     }else
    //     {
    //     arrType.push(element.text);
    //     }
    //   }
    //   if(element.bindingField=="typeall")
    //   {
    //    objfield["typeall"] = { "value": arrType, "text": "新客标签"};
    //   }
    // }
    if(element.formatter && element.formatter == "type" && element.bindingField=="typeall"){
      if(objfield["type2"].value||objfield["type3"].value||objfield["type4"].value||(objfield["type5"]&& objfield["type5"].value) || (objfield["type6"]&& objfield["type6"].value)|| (objfield["type7"]&& objfield["type7"].value)|| (objfield["type8"]&& objfield["type8"].value))
      {
        if(objfield["type2"]&&objfield["type2"].value)
        {
          arrType.push(objfield["type2"].text);
        }
        if(objfield["type3"]&&objfield["type3"].value)
        {
          arrType.push(objfield["type3"].text);
        }
        if(objfield["type4"]&&objfield["type4"].value)
        {
          arrType.push(objfield["type4"].text);
        }
        if(objfield["type5"]&&objfield["type5"].value)
        {
          arrType.push(objfield["type5"].text);
        }
        if(objfield["type6"]&&objfield["type6"].value)
        {
          arrType.push(objfield["type6"].text);
        }
        if(objfield["type7"]&&objfield["type7"].value)
        {
          arrType.push(objfield["type7"].text);
        }
        if(objfield["type8"]&&objfield["type8"].value)
        {
          arrType.push(objfield["type8"].text);
        }
      }else
      {
        arrType.push(objfield["type1"].text);
      }
      // if(objfield["type1"]&&objfield["type1"].value){
      //   arrType.push(objfield["type1"].text);
      // }else{
      //   arrType=[];
      // if(objfield["type2"]&&objfield["type2"].value)
      // {
      //   arrType.push(objfield["type2"].text);
      // }
      // if(objfield["type3"]&&objfield["type3"].value)
      // {
      //   arrType.push(objfield["type3"].text);
      // }
      // if(objfield["type4"]&&objfield["type4"].value)
      // {
      //   arrType.push(objfield["type4"].text);
      // }
    // }
    objfield["typeall"] = { "value": arrType, "text": "新客标签"};
  }
    return objfield;
   }
     /**
   * 是否android手机（针对pc端）
   */
  get isWxAndroid():boolean{
    var u = window.navigator.userAgent.toLowerCase();
    let isandroid:any = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    if(isandroid){
      return true;
    }else{
      return false;
    }
  }
  /**
   * 是否IOS手机（针对pc端）
   */
  get isWxIOS():boolean{
      var u = window.navigator.userAgent.toLowerCase();
      let isIOS:any = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isIOS){
        return true;
      }else{
        return false;
      }
    }
    // 预览文件支持安卓/ios

downloadFile(filename:any,filepath:any):Promise<string>{
  const that =this;
  return new Promise<string>((reject,resolve)=>{
  //   if (window["plus"]) {//支持plus
  //     let fileUrl=encodeURI(filepath);
  //     //判断文件是否已经下载
  //     plus.io.resolveLocalFileSystemURL(
  //         '_downloads/' + filename,
  //         function (entry) {//如果已存在文件，则打开文件
  //             if (entry.isFile) {
  //                 plus.runtime.openFile('_downloads/' + filename,{},function(error){
  //                   resolve(error);
  //                 });
  //             }
  //         }, function () {//如果未下载文件，则下载后打开文件
  //             var dtask = plus.downloader.createDownload(fileUrl, { filename: '_downloads/' + filename }, function (d, status) {
  //                 if (status == 200) {
  //                     reject(d);
  //                     plus.runtime.openFile('_downloads/' + filename,{},function(error){
  //                       that.msg.Alert(JSON.stringify(error));
  //                     });
  //                 }
  //                 else {
  //                   resolve(d);
  //                    that.msg.Alert("文件预览失败");

  //                 }
  //             });
  //             dtask.start();
  //         }
  //     );
  // } else {//不支持plus
  //   that.msg.Alert("不支持plus").then(msg=>{
  //     that.iab.create(filepath);
  //   })
      
  // }
  });

}
 /**
     * 浏览轨迹
     * @param historyurl 存储当前的记录名称
     */
    setBrowsingHistory(historyurl:string){
      const that=this;
      that.SetBrowsHistorystring("_imei",historyurl.toLowerCase());
    }
    /**
     * 跳转连接 url,obj不能同时为空
     * @param url 跳转的url名称,例如:https://xxx.xxxxx.com| localhost:8080;
     * @param obj 是否数组,主要针对跳转时带queryParams参数时调用，例如 that.router.navigate(["http://xxx.xxxxxx.com"], {"queryParams":{}});
     */
    Go(url:string="",obj:any=null){
      const that=this;
      if(url || obj){
        that.setBrowsingHistory(url);
        if(url && !obj){
          that.router.navigateByUrl(url);
        }else{
          let _obj:any={"queryParams":obj};
          that.router.navigate([url], _obj);
        }
      }
  }
  /**
   * 返回方法
   * @param url 跳转的url
   */
  GoUrl(url){
    const that=this;
    that.router.navigateByUrl(url);
  }
    /**
     * 判断当前xml名称是否有历史缓存
     * @param historyurl 
     */
    GetBrowsingHistory(historyurl:string){
        const that=this;
        let isresult:boolean =false;
        const oldvalue:any = historyurl.toLowerCase();
        //1.0  先判断是否是一级菜单
        if(that.GetMenus.find(m=>m.Component.toLowerCase()==oldvalue)){
          isresult=true;
        }else{
          let _imeiArray:Array<any> = new Array<any>();
          _imeiArray=that.getSessionStorageInfo("_imei")||[];
          _imeiArray.forEach((el,index)=>{
            let decodeValue=that.decodeBase64(el)||"";
            if(decodeValue.indexOf(oldvalue)>=0){
              isresult=true;
            }
          });
        }
         return isresult;
      }
  
    /**
     * 获取存储的sessionStorage值
     * @param key 当前的key值
     */
    getSessionStorageInfo(key):any{
      let obj:any=sessionStorage.getItem(key)||null;
      if(obj){
        return JSON.parse(obj)||null;
      }else{
        return  null;
      }
    }
    /**
     * 
     * @param key 
     * @param value 
     */
    SetBrowsHistorystring(key:string,value:string):any{
     const that =this;
     let _temp:Array<any> = that.getSessionStorageInfo(key)||[];
     if(!_temp.find(y=>that.decodeBase64(y)==value)){
      let _value:any=that.encodeBase64(value);
      _temp.push(_value);
      sessionStorage.setItem(key,JSON.stringify(_temp));
     }
    }
}


